<template>
  <form class="column is-12" @submit.prevent="onSubmit">
    <div class="columns is-multiline">
      <div class="column is-12">
        <h3 class="title is-5">Datos de contacto</h3>
      </div>
      <div class="column is-8">
        <div class="field">
          <input type="text" class="input" id="fullname" v-model="customerData.fullName" placeholder="Nombre / Razón social">
        </div>
        <div class="field">
          <input type="text" class="input" id="contactName" v-model="customerData.contactName" placeholder="Nombre de contacto">
        </div>
        <div class="field">
          <input type="text" class="input" id="phone" v-model="customerData.phone" placeholder="Número de contacto">
        </div>
        <div class="field">
          <input type="text" class="input" id="email" v-model="customerData.email" placeholder="Email de contacto">
        </div>
      </div>
      <div class="column is-6">
        <button class="button is-black" :disabled="!customerData.fullName && !customerData.contactName && !customerData.phone && !customerData.email">Continuar</button>
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "CustomerForm",
  data() {
    return {
      customerData: {
        fullName: '',
        contactName: '',
        phone: '',
        mail: '',
      },
      flowData:{}
    }
  },
  methods: {
    onSubmit() {
      this.$emit('done', {
        key: 'customerData',
        customerData: this.customerData
      });
    }
  }
}
</script>

<style scoped>

</style>
